<template>
    <div class="cognizance-box">
<!--        个人印章-->
        <div class="personalBox">
            <div class="personal">
                <h4>个人印章</h4>
                <div>申请印章</div>
            </div>
            <div class="stamper">
                <div class="stamperImg">
                    <img src="../../assets/img/seal.png" alt="">
                </div>
                <p>个人签章</p>
                <div class="serialNumber">
                    印章编号: 15615646941651211515
                </div>
                <div class="dateBox">
                    创建日期 2022.10.12
                </div>
            </div>
        </div>
<!--        企业印章-->
        <div class="enterpriseBox">
            <div class="enterprise">
                <h4>企业印章</h4>
                <div>管理</div>
            </div>
            <div style="display: flex;flex-wrap: wrap">
                <div class="officialStampBox" v-for="item in 10">
                    <div class="officialStampImg">
                        <img src="../../assets/img/cachet.png" alt="">
                    </div>
                    <p>公章</p>
                    <div class="serialNumber">
                        印章编号: 15615646941651211515
                    </div>
                    <div class="dateBox">
                        创建日期 2022.10.12
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "seal"
    }
</script>

<style scoped>
    .cognizance-box {
        width: 100%;
        height: 93vh;
        overflow-y: scroll;
        margin: 0 auto;
    }
    .personalBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
        margin: 10px;
    }
    .personal{
        display: flex;
    }
    .personal>div{
        font-size: 14px;
        margin-left: 20px;
        width: 80px;
        color: #fff;
        border-radius: 5px;
        line-height: 23px;
        text-align: center;
        background-color: #3e62f6;
    }
    .stamper{
        padding: 10px;
        margin-top: 20px;
        width: 200px;
        height: 240px;
        border: 1px solid #dfdfe1;
    }

    .stamperImg{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 150px;
    }
    .serialNumber,
    .dateBox{
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 5px 0px;
        font-size: 14px;
        color: #b9b9bb;
    }
    .stamper>p,
    .officialStampBox>p{
        font-size: 14px;
        margin: 5px 0px;
    }
/*    企业印章*/
    .enterpriseBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
        margin: 10px;
    }
    .enterprise{
        display: flex;
    }
    .enterprise>div{
        font-size: 14px;
        background-color: #3e62f6;
        color: #fff;
        width: 50px;
        text-align: center;
        border-radius: 5px;
        margin-left: 20px;
    }
    .officialStampBox{
        margin-right: 70px;
        padding: 10px;
        width: 200px;
        height: 240px;
        border: 1px solid #dfdfe1;
        margin-top: 20px;
    }
    .officialStampImg{
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
